import type { Exercise } from '@fluent/types';

/**
 * Every audio clip an exercise can play, in the order it plays them — the one
 * list the lesson player's next-exercise preload and Home's lesson pre-cache
 * share. An exhaustive switch on purpose: a new exercise type is a compile
 * error here, not a clip that silently never gets cached (the old copies were
 * if-chains that a new type slipped through without a sound).
 */
export function exerciseAudioKeys(ex: Exercise): string[] {
  switch (ex.type) {
    case 'tap_pairs':
      return ex.pairs.flatMap((p) => (p.audio_key ? [p.audio_key] : []));
    case 'dialogue':
      return ex.lines.map((l) => l.audio_key);
    case 'phrase_intro':
      // The phrases course's card also carries an example sentence clip.
      return ex.example_audio_key ? [ex.audio_key, ex.example_audio_key] : [ex.audio_key];
    case 'listen_type':
    case 'listen_choose':
      return [ex.audio_key];
    case 'translate_typed':
    case 'translate_tap':
    case 'choose_correct':
    case 'cloze':
      return ex.audio_key ? [ex.audio_key] : [];
    case 'phrase_choice':
      // The prompt clip plays on mount (meaning / reply), the answer clip after the verdict.
      return [ex.prompt_audio_key, ex.audio_key].filter((k): k is string => Boolean(k));
    case 'grammar_tip':
      return [];
  }
}

/** Every clip of a list of exercises, in play order (duplicates kept — the cache dedupes). */
export function audioKeysOf(exercises: readonly Exercise[]): string[] {
  return exercises.flatMap(exerciseAudioKeys);
}
